module.exports = __webpack_public_path__ + "img/R04_OFF.8493abba.jpg";